import React from 'react'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { generateCompanyURI } from 'sagas/helpers/generateCompanyURI'

import { ListItemCollapsedProps } from './listItemCollapsed.types'
import * as S from './listItemCollapsed.styles'

export const ListItemCollapsed = ({ option }: ListItemCollapsedProps) => {
    const { t } = useTranslation()

    const { label, icon, path, ...props } = option

    return (
        <S.ListItemCollapsedWrapper>
            <S.OptionsItem as={NavLink} activeClassName="active" to={generateCompanyURI(path)} {...props}>
                {icon}

                <span className="sr-only">{t(label)}</span>
            </S.OptionsItem>
        </S.ListItemCollapsedWrapper>
    )
}
